/*
  Claude 04-11 (ms-video): sætter temaets autoafspillende videoer (<video-media autoplay>) på pause, når de er rullet
  ud af syne, og starter dem igen, når de kommer tilbage. Temaet starter dem selv første gang, de ses, men stopper
  dem aldrig igen, så alle videoer man har rullet forbi blev ved med at spille (og hente data) i baggrunden.
  Rører kun videoer, som allerede spiller; en video, kunden selv har sat på pause, startes ikke igen.
  Indlæses som modul fra snippets/media.liquid (samme URL køres kun én gang) og har sin egen vagt.
*/
(() => {
  if (window.msVideoLazy || !('IntersectionObserver' in window)) return;
  window.msVideoLazy = true;

  const SELECTOR = 'video-media[autoplay][type="video"]';
  const observed = new WeakSet();

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        if (target.msPaused) {
          target.msPaused = false;
          if (typeof target.play === 'function') target.play();
        }
      } else if (target.hasAttribute('playing') && typeof target.pause === 'function') {
        target.msPaused = true;
        target.pause();
      }
    });
  }, { rootMargin: '200px 0px' });

  const observe = (el) => {
    if (el && el.matches && el.matches(SELECTOR) && !observed.has(el)) {
      observed.add(el);
      io.observe(el);
    }
  };
  const scan = (root) => (root || document).querySelectorAll(SELECTOR).forEach(observe);

  scan();
  // Videoer, der kommer til senere (sektioner der genindlæses, varianter), fanges, når de begynder at spille
  document.addEventListener('media:play', (event) => observe(event.target));
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
